import React from 'react'
import classNames from 'classnames'
import BootstrapTable from 'react-bootstrap-table-next'
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";

export default class RunTemplateResultGrid extends React.Component {
  render() {
   
    const {objects} = this.props

    const fieldColumns = [{
      dataField: 'name',
      text: 'Field',
      sort: true
    }, {
      dataField: 'value',
      text: 'Value',
      sort: true
    }];
    const fields = objects.filter(obj => obj["objectType"] == "field")

    const tables = objects.filter(obj => obj["objectType"] == "table").map(table => {
      
      if(table["rows"].length > 0)
      {
        const columns = Object.keys(table["rows"][0]).map(key => {
          return {
            dataField: key,
            text: key,
            sort: true
          }
        });
      
        const data = table["rows"].map((row, index) => {
          var rowData = {}
          for (let [key, value] of Object.entries(row)) {
            rowData[key] = value["value"]
          }
          rowData["key"] = index;
        
          return rowData
        });

        return (
          <div className="run-template-result-grid-table">
            <h3 className="mB-10"><code>{table["name"]}</code> <small><code>{data.length}</code> rows, <code>{columns.length}</code> columns</small></h3>
              <BootstrapTable striped="true" keyField='key' data={data} columns={columns} />
          </div>
        )
      }
      else {
        // empty table
        return (
          <div className="run-template-result-grid-table">
            <h3 className="mB-10"><code>{table["name"]}</code> <small><code>0</code> rows, <code>0</code> columns</small></h3>
          </div>
        )
      }
    })

    const fieldsClassNames = classNames("run-template-result-grid-fields", {hidden: fields.length == 0})

    return (
      <div className="run-template-result-grid">
        <div className={fieldsClassNames}>
          <div className="title-wrap">
            <h3 className="">Fields</h3>
            <CSVLink
              data={fields}
              headers={fieldColumns.map((item) => {
                return {label: item.text, key: item.dataField};
              })}
              filename="Parser-Results.csv"
            >
              <Button variant="primary">
                Download as CSV
              </Button>
            </CSVLink>
          </div>
          <BootstrapTable keyField='name' data={ fields } columns={ fieldColumns } />
        </div>
        {tables}
      </div>
    );
  }
}
